import { Injectable } from '@angular/core';
import { catchError, map, Observable, of, tap } from 'rxjs';
import { SignalsSimpleStoreService } from '@core/services';
import { PasswordResetApiService } from './password-reset-api.service';

export interface PasswordResetSessionPayload {
  token: string;
  email: string;
}

export interface PasswordResetServiceState {
  loading: boolean;
  sessionPayload: PasswordResetSessionPayload;
}

@Injectable({
  providedIn: 'root',
})
export class PasswordResetService extends SignalsSimpleStoreService<PasswordResetServiceState> {
  constructor(private passwordResetApiService: PasswordResetApiService) {
    super();
    this.set('sessionPayload', {} as PasswordResetSessionPayload);
  }

  /**
   * Call validate session token API .
   * @returns {Observable<{ isValid: boolean }>} Observable of session token validation status.
   */
  validateSessionToken(): Observable<{ isValid: boolean }> {
    this.set('loading', true);

    return this.passwordResetApiService.validateSessionToken(this.getValue('sessionPayload')).pipe(
      map((res) => {
        return { isValid: res.isValid || false };
      }),
      tap(() => {
        this.set('loading', false);
      }),
      catchError(() => {
        return of({ isValid: false });
      }),
    );
  }

  /**
   * Call password reset API .
   * @returns {Observable<{ success: boolean }>} Observable of password update success status.
   */
  changePassword(password: string): Observable<{ success: boolean }> {
    const sessionPayload = this.getValue('sessionPayload');

    this.set('loading', true);

    return this.passwordResetApiService.changePassword({ ...sessionPayload, password }).pipe(
      map((res) => {
        return { success: res.success || false };
      }),
      tap(() => {
        this.set('loading', false);
      }),
      catchError(() => {
        return of({ success: false });
      }),
    );
  }
}
